export const SALES_COMMISSION_SCROLL_KEY = "sales_commission_scroll_pos";
export const SALES_COMMISSION_FILTER_KEY = "sales_commission_filters";
export const SALES_COMMISSION_REFETCH_KEY = "sales_commission_should_refetch";
